import { Capacitor } from "@capacitor/core";
import { FirebaseFirestore } from "@capacitor-firebase/firestore";

export const getPlatform = () => {
  try {
    return Capacitor.getPlatform();
  } catch (error) {
    console.warn("⚠️ Capacitor.getPlatform fehlgeschlagen, fallback auf web", error);
    return "web";
  }
};

export const isNativeFirestorePlatform = () => {
  const platform = getPlatform();
  return platform === "ios" || platform === "android";
};

export const removeNativeSnapshotListener = async (callbackId) => {
  if (!callbackId) return;

  try {
    await FirebaseFirestore.removeSnapshotListener({ callbackId });
    console.log("🟢 Native snapshot listener removed", { callbackId });
  } catch (error) {
    console.error("🟢 Native snapshot listener remove FAILED", error);
  }
};

export const extractNativeDocumentData = (result) => {
  const candidates = [
    result?.snapshot?.data,
    result?.data,
    result?.document?.data,
    result?.value,
    result?.fields,
  ];

  for (const candidate of candidates) {
    if (candidate && typeof candidate === "object" && !Array.isArray(candidate)) {
      return candidate;
    }
  }

  return {};
};

export const extractNativeDocuments = (result) => {
  const docs =
    result?.snapshot?.documents ||
    result?.documents ||
    result?.snapshot?.docs ||
    result?.docs ||
    result?.snapshots ||
    [];

  if (!Array.isArray(docs)) {
    return [];
  }

  return docs;
};